<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="pagexi"></a><a href="#/005_Content#list" id="list">Abbreviations</a></h1>
<p> </p>
<p class="paraindent1a"><b>Archives</b></p>
<table style="width:100%">
<colgroup>
<col style="width:20%"/>
<col style="width:80%"/>
</colgroup>
<tbody>
<tr>
<td>ANV</td>
<td class="td1">Algemeen Nederlands Verbond Library, Cape Town</td>
</tr>
<tr>
<td>CA</td>
<td class="td1">State Archives, Cape Archives Depot, Cape Town</td>
</tr>
<tr>
<td>CAD</td>
<td class="td1">State Archives, Central Archives Depot, Pretoria</td>
</tr>
<tr>
<td>CORY</td>
<td class="td1">Rhodes University, Cory Library, Grahamstown</td>
</tr>
<tr>
<td>DPL</td>
<td class="td1">Durban Public Library</td>
</tr>
<tr>
<td>INCH</td>
<td class="td1">University of the Free State, Institute for Contemporary History,
Bloemfontein</td>
</tr>
<tr>
<td>NFA</td>
<td class="td1">National Film and Video Archives, Pretoria</td>
</tr>
<tr>
<td>SABC</td>
<td class="td1">South African Broadcasting Corporation Sound Archives, Johannesburg</td>
</tr>
<tr>
<td>SAL</td>
<td class="td1">National Library of South Africa, Cape Town</td>
</tr>
<tr>
<td>UCT, ASL</td>
<td class="td1">University of Cape Town, African Studies Library</td>
</tr>
<tr>
<td>UCT, MA</td>
<td class="td1">University of Cape Town, Manuscripts and Archives</td>
</tr>
<tr>
<td>US</td>
<td class="td1">University of Stellenbosch Document Center</td>
</tr>
<tr>
<td>WITS (A)</td>
<td class="td1">University of Witwatersrand Archives</td>
</tr>
<tr>
<td>WITS (HP)</td>
<td class="td1">University of Witwatersrand, Historical Papers</td>
</tr>
</tbody>
</table>
<p class="paraindent1a"><b>Organizations and Institutions</b></p>
<table style="width:100%">
<colgroup>
<col style="width:20%"/>
<col style="width:80%"/>
</colgroup>
<tbody>
<tr>
<td>AAC</td>
<td class="td1">All African Convention</td>
</tr>
<tr>
<td>ACVV</td>
<td class="td1">Afrikaanse Christelike Vroue Vereneging [Afrikaner Christian
Women’s Organization]</td>
</tr>
<tr>
<td>ANC</td>
<td class="td1">African National Congress</td>
</tr>
<tr>
<td>ANCYL</td>
<td class="td1">African National Congress Youth League</td>
</tr>
<tr>
<td>Anti-CAD</td>
<td class="td1">Anti-Coloured Affairs Department</td>
</tr>
<tr>
<td>ANV</td>
<td class="td1">Algemeen Nederlands Verbond</td>
</tr>
<tr>
<td>APO</td>
<td class="td1">African Political Organisation</td>
</tr>
<tr>
<td>ATKV</td>
<td class="td1">Afrikaans Taal en Kultuur Vereniging [Afrikaans Language and
Cultural Association]</td>
</tr>
<tr>
<td>CATA</td>
<td class="td1">Cape African Teachers Association</td>
</tr>
<tr>
<td>CPNU</td>
<td class="td1">Coloured People’s National Union</td>
</tr>
<tr>
<td>DRC</td>
<td class="td1">Dutch Reformed Church</td>
</tr>
<tr>
<td>FAK</td>
<td class="td1">Federasie van Afrikaanse Kultuurverenigings [Federation of Afrikaans
Cultural Associations]</td>
</tr>
<tr>
<td><a id="pagexii">FRAC</a></td>
<td class="td1">Franchise Action Council</td>
</tr>
<tr>
<td>GRA</td>
<td class="td1">Genootskap van Regte Afrikaners [Fellowship of True Afrikaners]</td>
</tr>
<tr>
<td>NAD</td>
<td class="td1">Native Affairs Department</td>
</tr>
<tr>
<td>NEUM</td>
<td class="td1">Non-European Unity Movement</td>
</tr>
<tr>
<td>SAIC</td>
<td class="td1">South African Indian Congress</td>
</tr>
<tr>
<td>TEPA</td>
<td class="td1">Teachers Educational and Professional Association</td>
</tr>
<tr>
<td>TLSA</td>
<td class="td1">Teachers League of South Africa</td>
</tr>
<tr>
<td>TRC</td>
<td class="td1">Truth and Reconciliation Commission</td>
</tr>
<tr>
<td>UCT</td>
<td class="td1">University of Cape Town</td>
</tr>
<tr>
<td>WPBTL</td>
<td class="td1">Western Province Bantu Teachers League</td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Abbreviations.vue?43f3b4e2